import { ComponentProps, type JSX, ReactNode } from 'react';
import { DropdownMenuOption } from '../../types';
import Popover from '../Popover/Popover';
import DropdownMenuItems from './DropdownMenuItems';
import styles from './styles/styles.module.scss';

type DropdownMenuProps = Pick<
  ComponentProps<typeof Popover>,
  'anchor' | 'className' | 'containerMouseHandlers' | 'isOpen' | 'onCloseRequest' | 'placement' | 'returnFocusOnDeactivate' | 'testId'
> & {
  children?: ReactNode;
  options: DropdownMenuOption[];
  textVariant?: 'text100' | 'text200';
};

const DropdownMenu = ({ children, options, textVariant, ...popoverProps }: DropdownMenuProps): JSX.Element => (
  <Popover {...popoverProps} className={styles.popover}>
    <DropdownMenuItems className={popoverProps.className} options={options} textVariant={textVariant}>
      {children}
    </DropdownMenuItems>
  </Popover>
);

export default DropdownMenu;
